import apiClient from '../client';

/**
 * Validate a coupon code against the current cart.
 * @param {string} code
 * @param {object} cartData - { cartSubtotal, customerEmail, paymentMode, items, cartItemCount }
 */
export const validateCoupon = async (code, cartData = {}) => {
  const { data } = await apiClient.post('/coupons/validate', {
    code,
    cartSubtotal: cartData.cartSubtotal ?? 0,
    customerEmail: cartData.customerEmail ?? null,
    paymentMode: cartData.paymentMode ?? null,
    items: cartData.items ?? [],
    cartItemCount: cartData.cartItemCount ?? 0,
    marketCode: cartData.marketCode ?? null,
  });
  return data;
};

/**
 * The Buy X Get Y offer for the current cart (applied automatically by the server), or one the cart is close to.
 * Returns null when there is none (204).
 */
export const getCartOffer = async (cartData = {}) => {
  const res = await apiClient.post('/coupons/offer', {
    code: '',
    cartSubtotal: cartData.cartSubtotal ?? 0,
    customerEmail: cartData.customerEmail ?? null,
    paymentMode: cartData.paymentMode ?? null,
    items: cartData.items ?? [],
    cartItemCount: cartData.cartItemCount ?? 0,
    marketCode: cartData.marketCode ?? null,
  });
  return res.status === 204 ? null : res.data;
};

/**
 * Get browseable available coupons for the current cart.
 * Returns { applicable: [], almostApplicable: [], autoApply: [] }
 */
export const getAvailableCoupons = async (cartData = {}) => {
  const { data } = await apiClient.post('/coupons/available', {
    code: '',
    cartSubtotal: cartData.cartSubtotal ?? 0,
    customerEmail: cartData.customerEmail ?? null,
    paymentMode: cartData.paymentMode ?? null,
    items: cartData.items ?? [],
    cartItemCount: cartData.cartItemCount ?? 0,
    marketCode: cartData.marketCode ?? null,
  });
  return data;
};
